export default {
  addSelectedPlanCommit (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addSelectedPlanCommit", payload)
      resolve()
    })
  },
  setMyPlan (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setMyPlan", payload)
      resolve()
    })
  },
  addInvoicePlanAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addInvoicePlanCommit", payload)
      resolve()
    })
  },
  addSelectedModuleForPlanAction (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("addSelectedModuleForPlanCommit", payload)
      resolve()
    })
  }
}
